import React from 'react';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { useFormik } from 'formik';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '20px',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '20px',
    },
  },
  emailWrapper: {
    display: 'flex',
    marginTop: '20px',
    marginRight: '10px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  emailTextField: {
    height: '40px',
    width: '315px',
    marginRight: '10px',
    background: '#ffffff',
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    borderColor: '#000000',
    borderStyle: 'solid',
    borderWidth: '1px',
    padding: '12px 24px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '15px',
    },
  },
  emailSubmit: {
    borderRadius: '4px',
  },
  submitText: {
    color: '#FFFFFF',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    textTransform: 'none',
    fontSize: '18px'
  },
}));

const EmailForm = ({ actions, customStyles }) => {
  const classes = useStyles();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    onSubmit: (value) => {
      fetch('/api/email', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: value.email,
        }),
      }).then((_res) => {
        actions?.setSubmitted(true);
        actions?.setOpen(false);
      });
      formik.resetForm();
    },
  });

  const email = document.getElementById('email');

  email?.addEventListener('input', function (event) {
    if (email.validity.typeMismatch) {
      email.setCustomValidity('Please enter a valid email');
    } else {
      email.setCustomValidity('');
    }
  });

  return (
    <form className={classes.emailWrapper} onSubmit={formik.handleSubmit}>
      <Input
        id="email"
        name="email"
        type="email"
        placeholder="Get the latest updates first!"
        className={classes.emailTextField}
        disableUnderline
        onChange={formik.handleChange}
        value={formik.values.email}
        style={customStyles}
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className={classes.emailSubmit}
        >
        <Typography variant="h4" className={classes.submitText}>
          Submit
        </Typography>
      </Button>
    </form>
  );
};

export default EmailForm;
